import { type definitions } from './types.vm2';

export type Json =
  | string
  | number
  | boolean
  | null
  | { [key: string]: Json }
  | Json[];

export interface Database {
  // schema
  vm2: {
    Tables: {
      // tabelas do banco
      projetos_camadas: {
        // definir os possíveis campos do retorno do select
        Row: definitions['projetos_camadas'];
        // definir os possíveis campos de criação
        Insert: Partial<definitions['projetos_camadas']>;
        // definir os possíveis campos de atualização
        Update: Partial<definitions['projetos_camadas']>;
      };
      projetos_camadas_formularios: {
        // definir os possíveis campos do retorno do select
        Row: definitions['projetos_camadas_formularios'];
        // definir os possíveis campos de criação
        Insert: Partial<definitions['projetos_camadas_formularios']>;
        // definir os possíveis campos de atualização
        Update: Partial<definitions['projetos_camadas_formularios']>;
      };
      projetos_camadas_formularios_campos: {
        // definir os possíveis campos do retorno do select
        Row: definitions['projetos_camadas_formularios_campos'];
        // definir os possíveis campos de criação
        Insert: Partial<definitions['projetos_camadas_formularios_campos']>;
        // definir os possíveis campos de atualização
        Update: Partial<definitions['projetos_camadas_formularios_campos']>;
      };
    };
    Views: {
      [_ in never]: never;
    };
    Functions: {
      [_ in never]: never;
    };
    Enums: {
      [_ in never]: never;
    };
  };
}
